import { Button } from './ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from './ui/dialog'
import { toast } from './ui/use-toast'

import { useMutationSendPasswordReset } from '@/services'

interface SendPasswordResetDialogProps {
  user: {
    email: string
    orgId: string
  }
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function SendPasswordResetDialog({
  user,
  onOpenChange,
  open
}: SendPasswordResetDialogProps) {
  const sendPasswordResetMutation = useMutationSendPasswordReset(user.orgId)

  const handleSendPasswordReset = () => {
    sendPasswordResetMutation.mutate(
      { email: user.email },
      {
        onSuccess: () => {
          toast({
            title: 'Password reset email sent',
            description: `A password reset email was sent to ${user.email}.`
          })
          onOpenChange(false)
        },
        onError: (err) => {
          toast({
            title: 'Error sending password reset email',
            description: err?.message
          })
        }
      }
    )
  }

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-primary">
            Send password reset email
          </DialogTitle>
          <DialogDescription>
            This will email a password reset link to{' '}
            <span className="font-bold">{user.email}</span>. It also rescues
            users stuck in the FORCE_CHANGE_PASSWORD state by sending them a
            fresh reset code so they can sign in again.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="items-center justify-between flex w-full">
          <Button
            onClick={() => onOpenChange(false)}
            type="button"
            variant="outline"
          >
            Cancel
          </Button>
          <Button
            loading={sendPasswordResetMutation.isPending}
            onClick={handleSendPasswordReset}
            type="submit"
          >
            Send reset email
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
